<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <a-table
      v-else
      :columns="columns"
      :data-source="currentData"
      :row-class-name="rowItem"
      :pagination="false"
      class="table-list relate-table"
    >
      <div
        slot="truename"
        slot-scope="truename, record"
        class="develop-td"
      >
        <span>{{ truename }}</span>
        <div class="develop-group">
          <template v-if="record.groupname">
            [{{ record.groupname }}]
          </template>
        </div>
      </div>
      <div
        slot="relaterulename"
        slot-scope="relaterulename"
      >
        <relation-tooptip :text="relaterulename" />
        <!-- {{ relaterulename }} -->
      </div>
      <div
        slot="roleid"
        slot-scope="roleid, record"
      >
        <div class="op-tool-box">
          <a
            href="javascript:;"
            @click="linkInfo(record)"
          >{{ $t('message["413"]') }} </a>
        </div>
      </div>
    </a-table>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import RelationTooptip from './RelationTooptip'

export default {
  components: {
    RelationTooptip
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('config/relation', ['datas', 'datasReady']),
    ...mapGetters('config/relation', ['currentData']),
    columns () {
      const columns = [{
        dataIndex: 'truename',
        key: 'truename',
        title: this.$t('message["549"]'),
        scopedSlots: { customRender: 'truename' }
      }, {
        title: this.$t('message["1370"]'),
        dataIndex: 'fieldkeyname',
        key: 'fieldkeyname'
      }, {
        title: this.$t('message["408"]'),
        dataIndex: 'relaterulename',
        key: 'relaterulename',
        scopedSlots: { customRender: 'relaterulename' }
      }, {
        title: this.$t('message["79"]'),
        key: 'roleid',
        dadaIndex: 'roleid',
        scopedSlots: { customRender: 'roleid' }
      }]
      return columns
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('config/relation', ['']),
    linkInfo (item) {
      this.$router.push({ name: 'configRelationInfo', query: { roleid: item.roleid, groupid: item.groupid, userid: item.userid } })
    },
    rowItem () {
      return 'rowItem'
    }
  }
}
</script>
<style lang="scss" scoped>
  .develop-td {
    font-size: 12px;
    .develop-group {
      color: #999;
    }
  }
   .relate-rule-td {
      max-width: 500px;
      overflow: hidden;
      height: 24px;
      line-height: 24px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
</style>
<style>
  .relate-table td {
    vertical-align: middle
  }
</style>
